import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, TrendingUp, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-screen flex items-center py-6 overflow-hidden" data-id="element-167">
      {/* Background decorative elements */}
      <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-gold/20 blur-3xl -z-10" data-id="element-168" />
      <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-coral/10 blur-3xl -z-10" data-id="element-169" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-171">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-white border border-cream-dark shadow-sm mb-3 pt-[2px] pb-[2px] pl-[9px] pr-[9px] gap-[3px]" data-id="element-172">
            <span className="text-base" data-id="element-173">🧠</span>
            <span className="text-xs font-bold tracking-wide text-dark uppercase" data-id="element-174">
              Bienestar mental al alcance de tu mano
            </span>
          </div>

          <h1 className="text-2xl md:text-4xl font-display font-bold text-dark leading-[1.1] mb-4" data-id="element-175">
            Cuidá tu salud mental y transformá tu bienestar emocional{' '}
            <span className="text-coral relative inline-block" data-id="element-176">
              sin arruinar tu economía
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-gold opacity-70" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-177">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" data-id="element-178" />
              </svg>
            </span>
          </h1>

          {/* Book image directly below the title */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative w-full max-w-[220px] sm:max-w-[260px] mx-auto mb-4" data-id="element-179">
            <div className="absolute inset-0 bg-gold rounded-full blur-3xl opacity-20 transform translate-x-6 translate-y-6" data-id="element-180"></div>
            <img src="https://cdn.magicpatterns.com/uploads/12ngdjHn4WSawouPNPKBkp/ChatGPT_Image_9_jun_2026,_14_20_07.png" alt="Este libro es más barato que la terapia - Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-181" />
          </motion.div>

          <div className="flex flex-wrap items-center justify-center gap-2 mb-3 text-xs md:text-sm font-medium text-dark-light" data-id="element-182">
            <div className="flex items-center gap-1 bg-gold/20 px-2.5 py-1 rounded-md" data-id="element-183">
              <Star className="w-3.5 h-3.5 fill-gold text-gold" data-id="element-184" />
              <span data-id="element-185">4.9/5 Calificación de lectores</span>
            </div>
            <div className="flex items-center gap-1 bg-teal/10 px-2.5 py-1 rounded-md text-teal" data-id="element-186">
              <TrendingUp className="w-3.5 h-3.5" data-id="element-187" />
              <span data-id="element-188">+1.200 personas ya empezaron su cambio</span>
            </div>
          </div>

          <p className="md:text-base mb-4 max-w-2xl mx-auto text-[#0B0B0B] text-[12px]" data-id="element-189">
            El método más claro, práctico y científico para domar la ansiedad,
            silenciar a tu crítico interior y recuperar tu paz mental desde casa
            en Argentina.
          </p>

          <ul className="flex flex-wrap justify-center mb-5 gap-[1px]" data-id="element-190">
            {['Sin turnos eternos', 'Sin pagar fortunas por sesión', 'A tu propio ritmo', 'Con acceso digital inmediato'].map((item, index) => <li key={index} className="flex items-center gap-1.5 text-dark font-medium" data-id="element-191">
                <CheckCircle2 className="w-4 h-4 text-teal flex-shrink-0" data-id="element-192" />
                <span className="text-[10px]" data-id="element-193">{item}</span>
              </li>)}
          </ul>

          <div className="space-y-2" data-id="element-194">
            <Button className="w-full sm:w-auto text-base px-8 py-3.5" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-195">
              🧠 QUIERO EMPEZAR MI CAMBIO HOY
            </Button>
            <div className="flex items-center justify-center gap-2 text-xs text-dark-light font-medium" data-id="element-196">
              <ShieldCheck className="w-3.5 h-3.5 text-teal" data-id="element-197" />
              <span data-id="element-198">Pago seguro · Garantía de 7 días · Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}